import {
  USER_DATA,
  SET_USER_NAME,
  SetUserNameAction,
  INITIAL_USERS,
  // UserLoggedInAction,
  USER_LOGGEDIN,
  UserLoginParams,
  USER_LOGGEDOUT,
} from "./types"
import axios from "axios"

import { ThunkResult, storage } from ".."
import { API_URL } from "../../api/Definitions"
import { handleInitialData } from "../data/actions"

export function handleUserData(): ThunkResult<Promise<void>> {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}v1/user/`)
        .then((result) => {
          dispatch({ type: USER_DATA, payload: result.data })
          resolve(result.data)
        })
        .catch((err) => {
          reject(err.response)
        })
    })
  }
}

export function getUsers(): ThunkResult<Promise<void>> {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/v1/users-list`)
        .then((result) => {
          dispatch({ type: INITIAL_USERS, payload: result.data })
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export function setUserName(data: string): SetUserNameAction {
  return {
    type: SET_USER_NAME,
    payload: data,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loginUser({
  email,
  password,
}: UserLoginParams): ThunkResult<Promise<void>> {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_URL}/users/login`, { email, password })
        .then((res) => {
          storage.setItem("loginKey", res.data.token)
          dispatch({ type: USER_LOGGEDIN, payload: res.data._id })
          dispatch(handleInitialData()).then(() => {
            resolve()
          })
        })
        .catch((err) => {
          console.log(err.response)

          reject(err.response)
        })
    })
  }
}

export function loginWithToken(): ThunkResult<Promise<void>> {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}check-token`)
        .then((res) => {
          if (!res.data.validToken) {
            reject()
          } else {
            dispatch({ type: USER_LOGGEDIN, payload: res.data._id })
            dispatch(handleInitialData()).then(() => {
              resolve()
            })
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export function handleLogout(): ThunkResult<Promise<void>> {
  return (dispatch) => {
    return new Promise((resolve) => {
      storage.removeItem("loginKey")
      dispatch({ type: USER_LOGGEDOUT })
      resolve()
    })
  }
}
